// Centralized query keys for React Query
export const techFamiliesKeys = {
  // Planner related queries
  planner: {
    techFamilies: (search?: string) =>
      ['planner', 'tech-families', search ?? ''] as const,
  },
} as const;
